












import { Component, Vue } from 'vue-property-decorator';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';

@Component({
  components: { StTabs, AccountSettingsInvoice },
})
export default class RegenerateInvoice extends Vue {
  regenerateInvoiceId: number = 0;

  async regenerateInvoice(){
    await stAdminApi.regenerateInvoice(this.regenerateInvoiceId);
  }
}
